export const COOKIE_GDPR_CONSENT = "gridl-gdpr-cookie-consent-v1";

// durations
export const HOUR_IN_SECONDS = 60 * 60;
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24;
export const WEEK_IN_SECONDS = DAY_IN_SECONDS * 7;
export const MONTH_IN_SECONDS = DAY_IN_SECONDS * 30;
export const YEAR_IN_SECONDS = DAY_IN_SECONDS * 365;
